import React from "react";
import { Chart } from 'chart.js'
import i18n from "../../i18n";

export default class Gauge extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
  }

  componentDidMount() {
    this.myChart = new Chart(this.canvasRef.current, {
      type: 'bar',
      options: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,

        scales: {
          yAxes: {
            stacked: true,
            grid: { display: false }
          },
          x: {
            grid: { display: false }
          },
        },
        elements: { bar: { borderRadius: 0 } },
        plugins: { legend: { display: false } }
      },
      data: {
        labels: [""], // one value = one bar to display
        datasets: [{
          type: "bar",
          label: i18n.t("occupied"),
          data: [this.props.data[0]],
          backgroundColor: "#b7de92",
          borderWidth: 0,
          barPercentage: 1.0,
          categoryPercentage: 1.0,
          order: 2,
          barThickness: 10
        },
        {
          type: "bar",
          label: i18n.t("available"),
          data: [this.props.data[1]],
          backgroundColor: "#bdc5cc",
          borderWidth: 0,
          barPercentage: 1.0,
          categoryPercentage: 1.0,
          order: 3,
          barThickness: 10
        },
        {
          type: "bar",
          label: "Seuil complet",
          data: [this.props.data[2]],
          backgroundColor: "#f0ca9e",
          borderWidth: 0,
          barPercentage: 1.0,
          categoryPercentage: 1.0,
          order: 4,
          barThickness: 10
        },
        {
          type: "scatter",
          label: "",
          data: [this.props.data[0]],
          backgroundColor: "black",
          borderColor: "black",
          order: 1, /* draw on top */
          pointStyle: 'rectRot',
          pointRadius: 6,
          pointHoverRadius: 8,
          barThickness: 10
        }]
      }
    });
  }

  componentDidUpdate() {
    if (this.props.data !== undefined) {
      this.myChart.data.datasets[0].data = [this.props.data[0]];
      this.myChart.data.datasets[1].data = [this.props.data[1]];
      this.myChart.data.datasets[2].data = [this.props.data[2]];
      this.myChart.data.datasets[3].data = [this.props.data[0]];
      this.myChart.update();
    } else {
      this.myChart.clear();
    }
  }

  render() {
    return (
      <div style={{ height: "50px" }} >
        <canvas ref={this.canvasRef} />
      </div >
    );
  }
}